import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cdb623f6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=cdb623f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb623f6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Login: require('/builds/master/frontend/frontend-universe/components/login.vue').default})
